var lanejCustomizer = (function () {
  window.opts = {
    isMobile: window.matchMedia("(max-width: 767px)").matches,
    formId: $('[name="currentFormId"]').val(),
    is_product_cat: $("#single_product_wrapper").data("product-tag"),
    canvasWrapper: "sf-canvas-wrapper",
    is_brx_prod: is_brx,
    canvasSelector: "sf-canvas",
    fontElementHelper: "#font-style-helper",
    inputField: 'input[name="initial"]',
    languageSelector: 'input[name="lanej_language"]',
    inputOptionsSelector: ".customizer__values .variant-picker__input input",
    inputFontPosition:
      ".prod__option--textPosition .customizer-picker__option input",
    fontStyleWrapper: '[data-option-type="fontFamily"]',
    fontLanguageWrapper: '[data-option-type="fontLanguage"]',
    textColorWrapper: '[data-option-type="textColor"]',
    customTextColorWrapper: '[data-option-type="customTextColor"]',
    canvasInstance: {},
    applyFontOnHelperElement: function () {
      $(opts.fontElementHelper).css({
        fontFamily: opts.getSelectedFontFamily(),
      });
    },
    canvasWidth: 500,
    canvasHeight: 500,
    scaleText: 0.75,
    startLeft: 308,
    startTop: 209,
    emojiTop: 290,
    emojiHeight: 0,
    anglePosition: 0,
    defaultTextPosition: "center",
    canvasTextInstance: {},
    getMediaEle: function () {
      return opts.isMobile
        ? $(".sf-product-media__mobile")
        : $(".sf-product-media__desktop");
    },
    getSelectedColor: function () {
      return $('[name="3D Text Color"]:checked').data("option-value");
    },
    selectObject: function (objectName, instance) {
      let getRequestedObject = opts.canvasInstance
        .getObjects()
        .filter((obj, index) => {
          return obj.name.indexOf(objectName) !== -1 ? obj : false;
        });

      if (instance === "all") {
        return getRequestedObject;
      }
      return getRequestedObject[0];
    },
    // defaultFontFamily: "Baskerville10Pro",
    defaultFontFamily: "customFont",
    getSelectedFontFamily: function () {
      var _fontFamily = $(
        opts.fontStyleWrapper + " .customizer__values input:checked"
      ).data("option-value");
      return typeof _fontFamily != "undefined"
        ? _fontFamily
        : opts.defaultFontFamily;
    },
    getSelectedLanguage: function () {
      return $(
        opts.fontLanguageWrapper + " .customizer__values input:checked"
      ).data("option-value");
    },
    getSelectedTextColor: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("option-value");
    },
    getSelectedTextColorShadow: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("shadow");
    },
    getSelectedTextColorSroke: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("stroke-color");
    },
    getSelectedTextColorStrokeWidth: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("stroke-width");
    },
    getSelectedTextColorStrokeFill: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("stroke-fill-color");
    },
    getSelectedTextPosition: function () {
      if ($(opts.inputFontPosition + ":checked").val() != undefined) {
        return $(opts.inputFontPosition + ":checked")
          .val()
          .toLowerCase()
          .replaceAll(" ", "-");
      }
      return opts.defaultTextPosition;
    },
    getSelected3DTextColor: function () {
      return $(
        opts.customTextColorWrapper + " .customizer__values input:checked"
      ).data("option-value");
    },
    rendered3DTextGroup: [],
    restrictToDrawOnCanvas: function () {
      let input = $(opts.inputField),
        headerHeight = opts.isMobile
          ? $(".sf-header__mobile").innerHeight()
          : $(".sf-header__desktop").innerHeight();
      if (!opts.getSelectedFontFamily()) {
        console.log("Please select font option first..");
        $("html,body").animate(
          {
            scrollTop: $(opts.fontStyleWrapper).offset().top - headerHeight,
          },
          500
        );
        return false;
      }

      //------- collection code start here -------
      if (
        (opts.getSelectedTextPosition() == "top-right" &&
          input.val().length > 4) ||
        (opts.getSelectedTextPosition() == "center-bottom-small" &&
          input.val().length > 5)
      ) {
        return false;
      }
      //------- collection code end here -------

      if (input.val() == "") {
        console.log("Please type your text..");
        input.focus();
        return false;
      }
      return true;
    },
    coordinates: {
      startTop: 209,
      startLeft: 308,
      scaleText: 0.75,
      anglePosition: 0,
      charsLimit: 0,
      fontSize: 0,
    },
    fontTypes: {
      Orbitron: {
        weight: 500,
        limit: 4,
      },
      Tourney: {
        weight: "normal",
        limit: 4,
      },
      LaLuxesScript: {
        weight: "normal",
        limit: 7,
      },
      Baskerville10Pro: {
        weight: "bold",
        limit: 4,
      },
      customFont: {
        weight: 100,
        limit: 7,
      },
    },
    buildDefaultColorsList: function () {
      //return '';
      let colorsList = "",
        counter = 1;
      // console.log(`vale of i is ${i}`);
      console.log(opts.defaultColors);
      $.each(opts.defaultColors, function (i, v) {
        console.log(`vale of i is ${i}`);
        colorsList +=
          '<div class="prod__option-label--textColor variant-picker__input ' +
          (counter == 1 ? "active" : "") +
          '">';
        // if (v.title!='') {
        //  colorsList += 'sf__tooltip-item sf__tooltip-top';
        // }
        // colorsList += '" data-option-position="'+counter+'" data-option-type="customizer-text-color" ';
        // colorsList += '" data-option-type="color" ';
        // if (v.title!='') {
        //  colorsList += 'data-value="'+v.title+'"';
        // }
        // colorsList += '>';
        //colorsList += '<div class="sf__variant-swatch flex justify-center items-center">';
        colorsList +=
          '<input type="radio" id="customizer-text-color-' +
          counter +
          '" name="Text Color" data-option-value="#' +
          i +
          '" ';

        if (v.title != "") {
          colorsList += 'value="' + v.title + '"';
        } else {
          colorsList += 'value="code=#' + i + '"';
        }

        colorsList += 'data-shadow="' + v.shadow + '"';
        colorsList += 'data-stroke-color="' + v.stroke_color + '"';
        colorsList += 'data-stroke-width="' + v.stroke_width + '"';
        colorsList += 'data-stroke-fill-color="' + v.stroke_fill_color + '"';

        colorsList +=
          'form="' + opts.formId + '" ' + (counter == 1 ? "checked" : "") + ">";
        // colorsList += '<label data-option-type="color" for="customizer-text-color-'+counter+'" ';
        colorsList += '<label for="customizer-text-color-' + counter + '" ';
        colorsList +=
          'class="customizer__label textColor flex items-center justify-center cursor-pointer" ';
        colorsList +=
          v.title == "White"
            ? ' style="background-color: #' + i + ';border:1px solid black;">'
            : ' style="background-color: #' + i + ';">';
        colorsList += "</label>";
        //colorsList += '</div>';
        // if (v.title!='') {
        //  colorsList += '<span class="sf__tooltip-content capitalize">'+v.title+'</span>';
        // }
        colorsList += "</div>";
        counter++;
      });
      return colorsList;
    },
    build3DColorsList: function () {
      let colorsList = "",
        counter = 1,
        colors = Object.keys(lanejCustomFonts["3d"]["en"]);
      // -------- modified color list for collections lanejCustomizer code start ------
      if (opts.is_product_cat) {
        colors = Object.keys(lanejCustomFonts2["3d"]["en"]);
        console.log(colors);
      }
      $.each(colors, function (i, v) {
        let colorCodeReference = "",
          colorImageReference = "";

        if (opts.is_product_cat) {
          colorCodeReference = lanejCustomFonts2["3d"]["en"][v].colorCode;
          if (lanejCustomFonts2["3d"]["en"][v].colorImage != "") {
            colorImageReference = lanejCustomFonts2["3d"]["en"][v].colorImage;
          }
        } else {
          colorCodeReference = lanejCustomFonts["3d"]["en"][v].colorCode;
          if (lanejCustomFonts["3d"]["en"][v].colorImage != "") {
            colorImageReference = lanejCustomFonts["3d"]["en"][v].colorImage;
          }
        }

        colorsList +=
          '<div class="prod__option-label--textColor variant-picker__input ' +
          (v === "yellow" ? "active" : "") +
          '">';
        colorsList +=
          '<input type="radio" id="customizer-customText-color-' +
          counter +
          '" name="3D Text Color" data-option-value="' +
          v.toLowerCase() +
          '" ';
        colorsList += 'value="' + v.toUpperCase() + '"';
        colorsList +=
          'form="' +
          opts.formId +
          '" ' +
          (v === "yellow" ? "checked" : "") +
          ">";
        colorsList +=
          '<label for="customizer-customText-color-' + counter + '" ';
        colorsList +=
          'class="customizer__label textColor flex items-center justify-center cursor-pointer" ';

        if (colorImageReference) {
          colorsList +=
            ' style="background-size:contain;background-image: url(' +
            colorImageReference +
            ')">';
        } else {
          colorsList +=
            ' style="background-color: ' + colorCodeReference + '">';
        }

        colorsList += "</label>";
        colorsList += "</div>";
        counter++;
      });

      // --------  modified color list for collections lanejCustomizer code start ------
      $(".customTextColor-option-values").html(colorsList);
    },
    defaultColors: default_colors_list,
    renderColorsList: function () {
      $(".textColor-option-values").html(opts.buildDefaultColorsList());
    },
    totalWidthOf3DText: function () {
      var chars = $(opts.inputField).val().split(""),
        totalWidth = 0,
        scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608,
        spacing = 4,
        active3dColor = opts.getSelected3DTextColor();
      $.each(chars, function (i, v) {
        // let imageData = opts.get3DTextImageData('3d', 'en', active3dColor, v);
        let imageData = opts.get3DTextImageData(
          "3d",
          opts.getSelectedLanguage(),
          active3dColor,
          v
        );
        totalWidth = totalWidth + imageData.width * scaleText + spacing;
      });
      return totalWidth;
    },
    get3DTextImageData: function (fontType, language, color, character) {
      // -------- collections lanejCustomizer code start --------
      if (opts.is_product_cat) {
        if (
          opts.is_product_cat == "top-right-position" &&
          opts.getSelectedLanguage() == "en"
        ) {
          return lanejCustomFonts2[fontType][language][color][
            character.toLowerCase()
          ];
        }
        return lanejCustomFonts2[fontType][language][color][character];
      }
      // -------- collections lanejCustomizer code end --------

      return lanejCustomFonts[fontType][language][color][
        character.toLowerCase()
      ];
    },
    setNormalTextObjectValue: function (canvasObject, text) {
      canvasObject.set("text", text);
      // opts.canvasInstance.renderAll();
    },
    setCoordinatesBasedOnFont: function (fontType) {
      // console.log('from -> setCoordinatesBasedOnFont -> ', fontType);

      if (fontType === "customFont") {
        opts.specialFontsSetCoordinates();
      } else {
        opts.normalFontsSetCoordinates();

        let activeTextObject = opts.selectObject("normal-font", "first"),
          text = $(opts.inputField).val();

        if (activeTextObject != undefined) {
          if (activeTextObject.text != "") {
            opts.setNormalTextObjectValue(activeTextObject, text);
          } else {
            // add normal text on canvas
            opts.renderNormalTextOnCanvas(text);
          }
        }
      }
    },

    normalFontsSetCoordinates: function () {
      $(opts.textColorWrapper).slideDown("fast");
      $(opts.customTextColorWrapper).slideUp("fast");

      // set coordinates based on font family
      var fontSize = (100 * opts.canvasWidth) / 608,
        hEle = $(opts.fontElementHelper),
        tPos = opts.getSelectedTextPosition(),
        startPos = opts.canvasWidth / 2, // startLeft
        topPos = opts.canvasHeight / 2, // startTop
        angel = 0,
        activeTextObject = opts.selectObject("normal-font", "first");

      // remove the existing custom 3d fonts
      opts.removeExistingCustomFontText(
        opts.selectObject("alphabet_svg", "all")
      );

      if (tPos == "center-small" || tPos == "center-bottom-small") {
        fontSize = (80 * opts.canvasWidth) / 608;
      } else if (tPos == "right-bottom") {
        fontSize = (120 * opts.canvasWidth) / 608;
      } else {
        fontSize = (100 * opts.canvasWidth) / 608;
      }

      hEle.css("font-size", fontSize + "px");
      var hEleWidth = hEle[0].clientWidth; // reqSpace

      //console.log('tPos: ', tPos);
      //console.log('1: left: ', startPos);

      // Font Size
      if (
        tPos === "center" ||
        tPos === "center-small" ||
        tPos === "center-bottom-small"
      ) {
        /* centersmall || centerbottomsmall || centerbig */
        var availableSpace = (280 * opts.canvasWidth) / 608,
          factor = 2;
        while (hEleWidth > availableSpace) {
          fontSize = ((fontSize - factor) * opts.canvasWidth) / 608;
          hEle.css("font-size", fontSize + "px");
          factor++;
          hEleWidth = hEle[0].clientWidth;
          if (hEleWidth <= availableSpace) {
            break;
          }
        }
      }

      //console.log('2: left: ', startPos);

      // Text Position
      if (tPos === "center" || tPos === "center-small") {
        // centerbig || centersmall
        topPos = topPos - (40 * opts.canvasHeight) / 784;
        startPos = startPos - (hEleWidth * opts.canvasWidth) / 608;
      } else if (tPos === "vertical-center") {
        // centerbigvert
        var h = opts.canvasHeight,
          canvasStart = (680 * h) / 784, // Start position from bottom side
          blankSpace = (390 * h) / 784, // Space bettween bottom start and camera corner
          canvasEnd = (120 * h) / 784, // end position from bottom side
          cameraStart = (270 * h) / 784; // camera starting position

        if (hEleWidth > blankSpace) {
          let factor = 2;
          while (hEleWidth > blankSpace) {
            fontSize = ((fontSize - factor) * opts.canvasWidth) / 608;
            hEle.css("font-size", fontSize + "px");
            factor++;
            hEleWidth = hEle[0].clientWidth;
            if (hEleWidth <= blankSpace) {
              break;
            }
          }
        }

        startPos = startPos - ((fontSize / 2) * opts.canvasWidth) / 608;
        topPos = canvasStart - hEleWidth;
        topPos = canvasStart - (canvasStart - canvasEnd) / 2;
        if (topPos - hEleWidth / 2 < cameraStart) {
          let diff = cameraStart - (topPos - hEleWidth / 2);
          topPos = topPos + diff;
          let remianingSpace = canvasStart - (topPos + hEleWidth / 2);
          topPos = topPos + remianingSpace / 2;
        }
        topPos = topPos + hEleWidth / 2;
        angel = -90;
      } else if (tPos === "right-bottom") {
        // bottomrightbig
        var blankSpace = (390 * opts.canvasHeight) / 784, // Space bettween bottom start and camera corner
          firstChar = "",
          topSpace = 220,
          factor = 2;

        if (hEleWidth > blankSpace) {
          while (hEleWidth > blankSpace) {
            fontSize = ((fontSize - factor) * opts.canvasWidth) / 608;
            hEle.css("font-size", fontSize + "px");
            factor++;
            hEleWidth = hEle[0].clientWidth;
            if (hEleWidth <= blankSpace) {
              break;
            }
          }
        }

        startPos = (430 * opts.canvasWidth) / 608;
        startPos = startPos - fontSize;
        topPos = topPos + (topSpace * opts.canvasHeight) / 784;
        angel = -90;
      } else if (tPos === "center-bottom-small") {
        // centerbottomsmall
        topPos = topPos + (188 * opts.canvasWidth) / 608;
        startPos = startPos - (hEleWidth * opts.canvasWidth) / 608;
        angel = 0;
      }

      //console.log('3: left: ', startPos);

      if (activeTextObject != undefined) {
        if (
          tPos == "center" ||
          tPos == "center-small" ||
          tPos == "center-bottom-small"
        ) {
          // centerbig || centersmall || centerbottomsmall
          startPos = opts.canvasWidth / 2;
          startPos = startPos - hEleWidth / 2; // activeTextObject.width/2
        }

        if (tPos == "vertical-center") {
          // centerbigvert
          activeTextObject.top =
            activeTextObject.top + (10 * opts.canvasHeight) / 784;
        }
      }

      //console.log('4: left: ', startPos);

      //console.log('top:', topPos, 'left:', startPos, 'tPos', tPos);

      opts.coordinates.startTop = topPos;
      opts.coordinates.startLeft = startPos;
      opts.coordinates.anglePosition = angel;
      opts.coordinates.fontSize = fontSize;
    },

    specialFontsSetCoordinates: function () {
      $(opts.textColorWrapper).slideUp("fast");
      $(opts.customTextColorWrapper).slideDown("fast");

      if ($(opts.inputField).val() === "") {
        return;
      }

      setCoordinates();

      var hEle = $(opts.fontElementHelper),
        tPos = opts.getSelectedTextPosition(),
        startPos = opts.canvasWidth,
        topPos = opts.canvasHeight,
        angel = 0,
        activeTextObject = opts.selectObject("normal-font", "first"),
        scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608,
        spacing = 4,
        totalWidth = opts.totalWidthOf3DText(),
        requireSpace = totalWidth / 2,
        textCharacters = $(opts.inputField).val().split("");

      if (activeTextObject != undefined) {
        if (activeTextObject.text != "") {
          opts.setNormalTextObjectValue(activeTextObject, "");
        }
      }

      spacing = (4 * opts.canvasWidth) / 608;

      if (tPos == "center-bottom-small" || tPos == "center-small") {
        var maxwidth = (250 * opts.canvasWidth) / 608;
        if (totalWidth > maxwidth) {
          for (var i = 1; i < 50; i++) {
            opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;
            totalWidth = opts.totalWidthOf3DText();
            requireSpace = totalWidth / 2;
            if (totalWidth <= maxwidth) {
              break;
            }
          }
          scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;
        }
      }

      if (tPos == "vertical-center") {
        var startingPosition = (308 * opts.canvasWidth) / 608,
          requiredWidth = scaleText * 272,
          topPosition = (678 * opts.canvasHeight) / 784,
          maxwidth = (428 * opts.canvasHeight) / 784,
          angel = -90;

        requiredWidth = requiredWidth / 2;
        startingPosition = startingPosition - requiredWidth;

        if (totalWidth > maxwidth) {
          for (var i = 1; i < 50; i++) {
            opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;
            totalWidth = opts.totalWidthOf3DText();
            if (totalWidth < maxwidth) {
              break;
            }
          }
          scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;
        }
        if (maxwidth > totalWidth) {
          var diff = maxwidth - totalWidth;
          diff = diff / 2;
          topPosition -= diff;
        }
      } else if (tPos == "right-bottom") {
        var diff = 273 * scaleText,
          startingPosition =
            (opts.coordinates.startLeft * opts.canvasWidth) / 608 - diff,
          topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784,
          angel = -90;
      } else {
        // console.log(opts.startLeft, opts.canvasWidth, requireSpace);
        var startingPosition =
            (opts.coordinates.startLeft * opts.canvasWidth) / 608 -
            requireSpace,
          topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;
      }

      // --------  set angle for signature key chain start ---------
      if (opts.is_product_cat && opts.is_product_cat == "signature-keychain") {
        if ($(opts.inputField).val().length > 4) {
          return false;
        }
        angel = -90;
        startingPosition = 280;
        topPosition = 590;
      }
      if (
        opts.is_product_cat &&
        opts.is_product_cat == "top-right-position" &&
        textCharacters.length > 4
      ) {
        return false;
      }
      // -------- set angle for signature key chain end -----------

      fabric.Object.prototype.transparentCorners = false;

      // remove the existing custom fonts
      opts.removeExistingCustomFontText(
        opts.selectObject("alphabet_svg", "all")
      );

      // integrate text on canvas
      for (var i = 0; i < textCharacters.length; i++) {
        var char = textCharacters[i],
          imageData = opts.get3DTextImageData(
            "3d",
            opts.getSelectedLanguage(),
            opts.getSelected3DTextColor(),
            char
          );
        //console.log('startingPosition--loop  ', startingPosition);
        var properties = {
          left: startingPosition,
          top: topPosition,
          scaleX: scaleText,
          scaleY: scaleText,
          selectable: false,
          evented: false,
          angle: angel,
          name: "alphabet_svg" + i.toString(),
          crossOrigin: "Anonymous",
        };

        if (imageData.link) {
          $(opts.inputField).prop("disabled", true);
          fabric.Image.fromURL(
            imageData.link,
            function (oImg) {
              $(opts.inputField).prop("disabled", false);
              opts.canvasInstance.add(oImg);
              opts.rendered3DTextGroup.push(oImg);
            },
            properties
          );

          if (angel != 0) {
            topPosition = topPosition - imageData.width * scaleText - spacing;
          } else {
            startingPosition =
              startingPosition + imageData.width * scaleText + spacing;
          }
        }

        //console.log('startingPosition--loop  ', startingPosition);
      }
    },

    removeExistingCustomFontText: function (canvasInstances) {
      if (canvasInstances.length > 0) {
        for (let i = 0; i < canvasInstances.length; i++) {
          opts.canvasInstance.remove(canvasInstances[i]);
        }
      }
    },

    changeCanvasTextObject: function (type) {
      let properties = {};

      if (type === "textColor") {
        properties["fill"] = opts.getSelectedTextColorStrokeFill()
          ? opts.getSelectedTextColorStrokeFill()
          : opts.getSelectedTextColor();
        properties["shadow"] = opts.getSelectedTextColorShadow();
        properties["stroke"] = opts.getSelectedTextColorSroke();
        properties["strokeWidth"] = opts.getSelectedTextColorStrokeWidth();
      } else if (type === "fontFamily") {
        properties["fontFamily"] = opts.getSelectedFontFamily();
        properties["left"] = opts.coordinates.startLeft;
        properties["top"] = opts.coordinates.startTop;
        properties["fontSize"] = opts.coordinates.fontSize;
        properties["angle"] = opts.coordinates.anglePosition;
        properties["fill"] = opts.getSelectedTextColor();
      } else if (type === "customTextColor") {
        opts.specialFontsSetCoordinates(); // re-render 3d text of selected color
      }
      console.log(properties);
      if (
        opts.selectObject("normal-font", "first") != undefined &&
        type != "customTextColor"
      ) {
        opts.selectObject("normal-font", "first").setOptions(properties);
        opts.canvasInstance.renderAll();
        /* if(window.opts.canvasInstance.toDataURL()){
        alert("updated");
        $('#image_raw_content').val(window.opts.canvasInstance.toDataURL());
      }
      else{
        alert("not updated");
      }*/
      }
    },

    renderNormalTextOnCanvas: function (val) {
      if (Object.keys(opts.canvasTextInstance).length == 0) {
        let textProperties = {
          width: 200,
          selectable: false,
          fontFamily: opts.getSelectedFontFamily(),
          fontWeight: opts.fontTypes[opts.getSelectedFontFamily()]["weight"],
          left: opts.coordinates.startLeft,
          top: opts.coordinates.startTop,
          fontSize: opts.coordinates.fontSize,
          textAlign: "center",
          angle: opts.coordinates.anglePosition,
          fill: opts.getSelectedTextColorStrokeFill()
            ? opts.getSelectedTextColorStrokeFill()
            : opts.getSelectedTextColor(),
          name: "normal-font",
          shadow: opts.getSelectedTextColorShadow(),
          stroke: opts.getSelectedTextColorSroke(),
          strokeWidth: opts.getSelectedTextColorStrokeWidth(),
        };
        console.log(textProperties);

        opts.canvasTextInstance = new fabric.Text(val, textProperties);
        opts.canvasTextInstance.selectable = false;

        opts.canvasInstance.add(opts.canvasTextInstance);
        return;
      }

      let selectedObject = opts.selectObject("normal-font", "first");
      selectedObject.set("text", val);

      // if(product_cat){

      //   var $this = $('#sf-canvas');
      //   let textLength = $(opts.inputField).val().length;
      //   if(product_cat == 'signature-holder'){
      //       opts.coordinates.startLeft = textLength > 0 ? 285 - (textLength * 10) :  285 ,
      //       textProperties.left = textLength > 0 ? 285 - (textLength * 10) :  285,
      //       textProperties.top = 470,
      //       textProperties.fontSize = 50;
      //       textProperties.fill = opts.getSelectedTextColor() ? opts.getSelectedTextColor() : '#000';
      //   }

      //   if(opts.getSelectedFontFamily() == 'LaLuxesScript'){
      //       textProperties.fontSize = 70;
      //       opts.coordinates.scaleText = 2;
      //   }
      //   console.log(opts.getSelectedFontFamily())
      // }

      selectedObject.setOptions({
        left: opts.coordinates.startLeft,
        top: opts.coordinates.startTop,
        fontSize: opts.coordinates.fontSize,
        angle: opts.coordinates.anglePosition,
        fill: opts.getSelectedTextColor(),
        selectable: false,
      });

      opts.canvasInstance.renderAll();
      //if(window.opts.canvasInstance.toDataURL()){$('#image_raw_content').val(window.opts.canvasInstance.toDataURL());}
    },

    setInputLimitBaseOnFontType: function (fontFamily) {
      let input = $(opts.inputField),
        fontLimit = opts.fontTypes[fontFamily]["limit"];

      input.attr("maxlength", fontLimit);
      input.val(input.val().substring(0, fontLimit)).trigger("keyup");
    },
  };

  var getImageUrl = function () {
    console.log(opts.getMediaEle().find(".swiper-container").length);
    console.log(
      opts
        .getMediaEle()
        .find(".swiper-wrapper .swiper-slide-active img")
        .attr("src")
    );
    console.log(
      opts
        .getMediaEle()
        .find(".swiper-wrapper .swiper-slide:eq(0) img.f-img-loaded")
        .attr("src")
    );
    if (opts.getMediaEle().find(".swiper-container").length > 0) {
      return opts
        .getMediaEle()
        .find(".swiper-wrapper .swiper-slide-active img")
        .attr("src");
    } else {
      return opts
        .getMediaEle()
        .find(".swiper-wrapper .swiper-slide:eq(0) img.f-img-loaded")
        .attr("src");
    }
  };

  var setCoordinates = function () {
    var textChar = $('input[name="initial"]').val().length;

    if (
      opts.getSelectedTextPosition() == "center-small" ||
      opts.getSelectedTextPosition() == "center-bottom-small"
    ) {
      opts.coordinates.fontSize = (80 * opts.canvasWidth) / 608;
    } else if (opts.getSelectedTextPosition() == "right-bottom") {
      opts.coordinates.fontSize = (120 * opts.canvasWidth) / 608;
    } else {
      opts.coordinates.fontSize = (100 * opts.canvasWidth) / 608;
    }

    switch (opts.getSelectedTextPosition()) {
      case "center":
        opts.coordinates.startTop = 338;
        opts.coordinates.startLeft = 308;
        opts.coordinates.scaleText = 0.5 + 0.1 * (textChar - 1);
        opts.coordinates.scaleText =
          opts.coordinates.scaleText / (textChar * 0.9);
        opts.coordinates.anglePosition = 0;
        opts.coordinates.charsLimit = 5;

        // collections lanejCustomizer code start ------
        console.log(opts.is_product_cat);
        if (opts.is_product_cat) {
          opts.coordinates.startTop = 430;
          // opts.coordinates.scaleText = 0.59;
          opts.coordinates.scaleText = 0.7;
          opts.coordinates.charsLimit = 5;

          if (opts.is_product_cat == "grande-card-holder") {
            opts.coordinates.startTop = 514;
          }
          if (opts.is_product_cat == "signature-holder") {
            opts.coordinates.startTop = 420;
          }
          if (opts.is_product_cat == "top-right-position") {
            opts.coordinates.startTop = 140;
            opts.coordinates.startLeft = 385;
            opts.coordinates.charsLimit = 3;
          }
          if (opts.is_product_cat == "bi-fold-holder") {
            opts.coordinates.startTop = 540;
            opts.coordinates.startLeft = 434;
            let charecters = $(opts.inputField).val();
            let color = opts.getSelectedColor();
            let minusLeft = 0;
            for (let i = 0; i < charecters.length; i++) {
              if (opts.getSelectedLanguage() == "en") {
                minusLeft +=
                  lanejCustomFonts2["3d"][opts.getSelectedLanguage()][color][
                    charecters[i]
                  ]["width"] /
                    2 -
                  2;
              } else {
                minusLeft += 40 / 2 - 2; // lanejCustomFonts2['3d'][opts.getSelectedLanguage()][color][charecters]['width']
              }
            }

            opts.coordinates.startLeft = opts.coordinates.startLeft - minusLeft;
          }
          if (opts.is_product_cat == "signature-keychain") {
            //opts.coordinates.anglePosition = -90;
          }
          $(opts.inputField).attr("maxlength", opts.coordinates.charsLimit);
        }
        // collections lanejCustomizer code end  ------

        break;
      case "vertical-center":
        opts.coordinates.startTop = 438;
        opts.coordinates.startLeft = 268;
        opts.coordinates.scaleText = 0.54 - 0.05 * textChar;
        opts.coordinates.anglePosition = -90;
        break;

      case "right-bottom":
        opts.coordinates.scaleText = 0.54 - 0.05 * textChar;
        opts.coordinates.startTop = 662;
        opts.coordinates.startLeft = 424;
        opts.coordinates.anglePosition = -90;
        opts.coordinates.fontSize = (120 * opts.canvasWidth) / 608;
        break;

      case "center-bottom-small":
        opts.coordinates.startTop = 545;
        opts.coordinates.startLeft = 308;
        opts.coordinates.scaleText = 0.7;
        opts.coordinates.anglePosition = 0;
        opts.coordinates.charsLimit = 5;
        break;
      case "center-small":
        opts.coordinates.startTop = 338;
        opts.coordinates.startLeft = 308;
        opts.coordinates.scaleText = 0.2;
        opts.coordinates.anglePosition = 0;
        break;
      case "top-right":
        opts.coordinates.startTop = 140;
        opts.coordinates.startLeft = 385;
        opts.coordinates.charsLimit = 4;
        break;
    }
  };

  var createCanvas = function () {
    opts.canvasInstance = window._canvas = new fabric.Canvas(
      opts.canvasSelector,
      {
        selection: false,
        controlsAboveOverlay: true,
        centeredScaling: true,
        allowTouchScrolling: true,
      }
    );
    updateCanvasSize();

    applyFontStylesOnLabels();
    opts.renderColorsList();
    opts.build3DColorsList();

    // active font type on element
    opts.applyFontOnHelperElement();

    $(".canvas-container canvas").show();

    switchProductImage();

    if (window.opts.is_brx_prod == true) {
      $("#font_style_baskerville10Pro").click();
    } else {
      $("#font_style_customFont").click();
    }
  };

  var updateCanvasSize = function () {
    opts.canvasWidth = opts.getMediaEle().width();
    opts.canvasHeight = opts.getMediaEle().height();
    $("#" + opts.canvasWrapper).height(opts.canvasHeight);
    opts.canvasInstance.setWidth(opts.canvasWidth);
    opts.canvasInstance.setHeight(opts.canvasHeight);
    opts.canvasInstance.on("after:render", function () {
      // call the save function here
      //$('#image_raw_content').val(window.opts.canvasInstance.toDataURL());
      // alert('rendered');
    });
  };

  var switchProductImage = function () {
    setProductImage();
  };

  var applyFontStylesOnLabels = function () {
    $('[data-option-type="fontFamily"] .variant-picker__input').each(
      function () {
        let fontType = $(this).find("input").data("option-value");
        console.log(
          opts.fontTypes[fontType]
            ? opts.fontTypes[fontType]["weight"]
            : "inherit"
        );
        $(this)
          .find("label")
          .css({
            fontFamily: fontType,
            fontWeight: opts.fontTypes[fontType]
              ? opts.fontTypes[fontType]["weight"]
              : "inherit",
          });
      }
    );
  };

  var setProductImage = function (link) {
    let imgSrc = typeof link != "undefined" ? link : getImageUrl();
    console.log(imgSrc);
    fabric.Image.fromURL(
      imgSrc,
      function (img) {
        var canvasAspect = opts.canvasWidth / opts.canvasHeight;
        var imgAspect = img.width / img.height;
        var imgPositionLeft, imgPositionTop, canvasScale;
        if (canvasAspect >= imgAspect) {
          var canvasScale = opts.canvasWidth / img.width;
          imgPositionLeft = 0;
          imgPositionTop = -(img.height * canvasScale - opts.canvasHeight) / 2;
        } else {
          var canvasScale = opts.canvasHeight / img.height;
          imgPositionTop = 0;
          imgPositionLeft = -(img.width * canvasScale - opts.canvasWidth) / 2;
        }
        img.set({
          top: imgPositionTop,
          left: imgPositionLeft,
          originX: "left",
          originY: "top",
          scaleX: canvasScale,
          scaleY: canvasScale,
        });
        opts.canvasInstance.setBackgroundImage(
          img,
          opts.canvasInstance.renderAll.bind(opts.canvasInstance)
        );
      },
      {
        /* crossOrigin: 'Anonymous'*/
      }
    );
  };

  // event handlers
  $(opts.inputField).on("keyup", function (e) {
    let currentText = $(opts.inputField).val();
    if (currentText.length > 5) {
      $(this).val($(this).val().slice(0, 5));
      return false;
    }

    if (!opts.restrictToDrawOnCanvas()) {
      opts.removeExistingCustomFontText(opts.selectObject("alphabet_svg", "all"));
      $(this).val("");
      return false;
    }

    let ele = $(this),
      val = ele.val(),
      inputParent = ele.closest(".variant-picker__input");

    if (val.match(/[^a-zA-Z0-9♥♡٠!]/g) && opts.getSelectedLanguage() != "ar") {
      ele.val(val.replace(/[^a-zA-Z0-9♥♡٠!]/g, ""));
      return;
    }

    inputParent.find(".selected-value").html(val);
    $(opts.fontElementHelper).html(val);

    opts.setCoordinatesBasedOnFont(opts.getSelectedFontFamily());

    if (opts.getSelectedFontFamily() !== "customFont") {
      opts.renderNormalTextOnCanvas(val);
    }
    // else {
    //   opts.render3DTextOnCanvas(val);
    // }
  });
  $(opts.inputField).on("input", function (e) {
    if (
      window.opts.getSelectedFontFamily() == "Baskerville10Pro" &&
      this.value
    ) {
      this.value = this.value.toUpperCase();
      // val = val.toUpperCase();
    }
  });

  $(opts.inputFontPosition).on("click", function (e) {
    if (
      opts.getSelectedTextPosition() == "top-right" &&
      $(opts.inputField).val().length > 4
    ) {
      $(opts.inputField).val($(opts.inputField).val().slice(0, -1));
    }
    if (!opts.restrictToDrawOnCanvas()) {
      return false;
    }

    opts.setCoordinatesBasedOnFont(opts.getSelectedFontFamily());

    opts.selectObject("normal-font", "first").setOptions({
      left: opts.coordinates.startLeft,
      top: opts.coordinates.startTop,
      fontSize: opts.coordinates.fontSize,
      textAlign: "center",
      angle: opts.coordinates.anglePosition,
      fill: opts.getSelectedTextColor(),
    });

    opts.canvasInstance.renderAll();
    /*   if(window.opts.canvasInstance.toDataURL()){
        alert("updated");
        $('#image_raw_content').val(window.opts.canvasInstance.toDataURL());
      }
      else{
        alert("not updated");
      }*/
  });

  $(opts.languageSelector).on("change", function (e) {
    $(".languageSelector").find(".active-radio-ae").removeClass("activecc");
    $(this)
      .closest(".languageSelector")
      .find(".active-radio-ae")
      .addClass("activecc");
    $(opts.inputField).val("");
    if (opts.getSelectedLanguage() == "ar") {
      // $("#cc_eng_textbox").hide();
      // $("#cc_arabic_text_icon").show();
      $("#cc_eng_textbox").addClass("ccClicktoOpenMenu");
      $("li[data-id='font_style_baskerville10Pro']").hide();
      $("li[data-id='font_style_laLuxesScript']").hide();
      $(
        "#cc_en_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).removeClass("open");
    } else {
      $("#cc_eng_textbox").removeClass("ccClicktoOpenMenu");
      $(".dropdown-menu").removeClass("open");
      // $("#cc_eng_textbox").show();
      // $("#cc_arabic_text_icon").hide();
      $("li[data-id='font_style_baskerville10Pro']").show();
      $("li[data-id='font_style_laLuxesScript']").show();
    }

    opts.removeExistingCustomFontText(opts.selectObject("alphabet_svg", "all"));
  });
  $("#cc_eng_textbox .icon-heart-focus").click(function () {
    if (opts.getSelectedLanguage() == "ar") {
      $(
        "#cc_en_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).removeClass("open");
      $(
        "#cc_arabic_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).toggleClass("open");
    } else {
      $(
        "#cc_arabic_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).removeClass("open");
      $(
        "#cc_en_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).toggleClass("open");
    }
  });

  $(document).on("click", opts.inputOptionsSelector, function () {
    let ele = $(this),
      parent = ele.closest(".customizer-wrapper"),
      wrapType = parent.data("option-type");

    if (wrapType === "textColor") {
      console.log($(this).val());
      if (!opts.restrictToDrawOnCanvas()) {
        return false;
      }
      if ($("variant-image").length) {
        $(`variant-image input[value="${$(this).val()}"]`).click();
      }
    } else if (wrapType === "fontFamily") {
      opts.applyFontOnHelperElement();
      // apply some fontsize, coordinates calc based on font type
      opts.setCoordinatesBasedOnFont(ele.data("option-value"));

      // max length input limit
      opts.setInputLimitBaseOnFontType(ele.data("option-value"));
    }

    parent.find(".variant-picker__input").removeClass("active");
    ele.parent().addClass("active");
    parent.find(".form__label .selected-value").html(ele.val());

    opts.changeCanvasTextObject(wrapType);
  });

  $(document).on("click", ".pdp-fs-list", function () {
    $(this).toggleClass("active");
  });

  $(document).on("click", ".pdp-fs-list ul li", function () {
    if ($(this).hasClass("active")) {
      return;
    }
    $(".pdp-fs-list ul li").removeClass("active");
    $(this).addClass("active");
    $(".selected-font-style img").attr("src", $(this).find("img").attr("src"));
    $("#" + $(this).data("id")).click();
    //alert($(this).data("id"));
    //alert($(this).find('img').attr('src'));
  });

  return {
    init: createCanvas,
    switchColorSwatch: switchProductImage,
    // selectArAlphabet: selectArAlphabet
  };
})();

$(function () {
  lanejCustomizer.init();
});

var selectArAlphabet = function (char, image) {
  let currentText = $('input[name="initial"]').val();
  if (currentText.length >= 5) {
    return false;
  }
  if ($('input[name="lanej_language"]:checked').val() == "ar") {
    $('input[name="initial"]').val(char + currentText);
  } else {
    $('input[name="initial"]').val(currentText + char);
  }
  $('input[name="initial"]').keyup();
};

console.log("LANEJ TOP RIGHT CUSTOMIZABLE::");

/* CC - js UPDATES ON 26-4-2023 - START */
$(document).ready(() => {
  $("span.option-label").click(function (e) {
    e.preventDefault();
    console.log("selected");
    $(this).addClass("selected-value").siblings().removeClass("selected-value");
  });
});
/* CC - js UPDATES ON 26-4-2023 - END */
